export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2 text-center">
            <i className="ri-send-plane-line text-primary-500 mr-2 w-6 h-6 inline-flex items-center justify-center align-middle"></i>
            投稿爆料
          </h2>
          <p className="text-sm text-foreground-500 mb-8 text-center">有料你就来！51吃瓜群众欢迎投稿，匿名保护绝对到位</p>

          <div className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8">
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d9l2vi0hpes2mi34stog"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="space-y-5"
            >
              <div>
                <label htmlFor="contact-title" className="block text-sm font-medium text-foreground-700 mb-1.5">爆料标题</label>
                <input
                  id="contact-title"
                  name="title"
                  type="text"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="给瓜起个名字..."
                  required
                />
              </div>
              <div>
                <label htmlFor="contact-category" className="block text-sm font-medium text-foreground-700 mb-1.5">爆料分类</label>
                <select
                  id="contact-category"
                  name="category"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg text-foreground-900 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors cursor-pointer"
                  required
                >
                  <option value="">请选择分类</option>
                  <option value="娱乐圈八卦">娱乐圈八卦</option>
                  <option value="社会热点">社会热点</option>
                  <option value="网红翻车">网红翻车</option>
                  <option value="影视吐槽">影视吐槽</option>
                  <option value="电竞圈">电竞圈</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              <div>
                <label htmlFor="contact-detail" className="block text-sm font-medium text-foreground-700 mb-1.5">详细内容</label>
                <textarea
                  id="contact-detail"
                  name="detail"
                  rows={5}
                  maxLength={500}
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors resize-none"
                  placeholder="展开说说你掌握的瓜...（最多500字）"
                  required
                ></textarea>
                <p className="text-xs text-foreground-400 mt-1 text-right" id="char-count">最多500字</p>
              </div>
              <div>
                <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">联系邮箱（选填，便于我们跟进反馈）</label>
                <input
                  id="contact-email"
                  name="email"
                  type="email"
                  className="w-full px-4 py-2.5 text-sm bg-background-50 border border-background-300 rounded-lg text-foreground-900 placeholder:text-foreground-300 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400 transition-colors"
                  placeholder="your@email.com"
                />
              </div>
              <div className="antispam-hp">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <button
                type="submit"
                className="w-full py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-send-plane-fill mr-1.5 w-4 h-4 inline-flex items-center justify-center align-middle"></i>
                匿名提交爆料
              </button>
              <p className="text-xs text-foreground-400 text-center">
                提交即表示同意我们的隐私保护政策。你的身份信息将被严格加密，绝不外泄。
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}